// Store front events to Google Analytics 4 (aldoo-ra Tracking/google), in the
// store front's GA4 items (./ga4): the product page, a favorite, the lists and
// a pick from one, a search.
import PubSub from "pubsub-js"
import { ga4Item, track } from "./ga4"

export function trackViewItem(product) {
  if (!product?.pid) return
  track("Tracking_ViewItem", [ga4Item(product)])
}

export function trackAddToWishlist(product) {
  if (!product?.pid) return
  track("Tracking_AddToWishlist", [ga4Item(product)])
}

// ── lists: the products a row, a grid or a search shows (view_item_list), and
// the one opened from it (select_item). A card reports itself as it appears;
// the cards of one list a moment apart go out as one event.
// the lists' names in the reports, by placement (store/placements)
const LIST_NAMES = {
  home: "Home page rows",
  category: "Category page",
  search: "Search results",
  seller_page: "Seller page",
  content_type: "Content type page",
  author_page: "Author page",
  creators: "Creators page",
  library: "Library",
  recently_viewed: "Recently viewed",
  see_also: "See also",
  more_by_author: "More by the author",
  more_from_series: "More from the series",
  series_banner: "Series Banner",
  related: "Related products",
  unavailable: "Unavailable product page",
  cart_upsell: "Cart upsell (Get a good deal)",
}

/** The list a placement stands for, or null where a card is no list's (a product page's own buttons). */
export const listOf = (placement) => (placement && LIST_NAMES[placement] ? { id: placement, name: LIST_NAMES[placement] } : null)

const pending = new Map()
const seen = new Set()
const LIST_DELAY = 800

/** A card of a list on screen: `list` { id, name }, `index` its place. */
export function trackListImpression(product, list, index) {
  if (!product?.pid || !list?.id) return
  const key = `${window.location.pathname}|${list.id}|${product.pid}`
  if (seen.has(key)) return
  seen.add(key)
  const entry = pending.get(list.id) || { list, items: [], timer: null, count: 0 }
  // its place: as given, else the order the list's cards appeared in
  entry.items.push(ga4Item(product, { list, index: Number.isInteger(index) ? index : entry.count }))
  entry.count += 1
  clearTimeout(entry.timer)
  entry.timer = setTimeout(() => {
    pending.delete(list.id)
    track("Tracking_ViewItemList", entry.items, { item_list_id: list.id, item_list_name: list.name })
  }, LIST_DELAY)
  pending.set(list.id, entry)
}

/** A card opened from a list. */
export function trackSelectItem(product, list, index) {
  if (!product?.pid) return
  track("Tracking_SelectItem", [ga4Item(product, { list, index })], list?.id ? { item_list_id: list.id, item_list_name: list.name } : {})
}

/** A search the visitor ran (the header's search box, a search results page). */
export function trackSearch(term) {
  const text = String(term || "").trim()
  if (text.length < 2) return
  PubSub.publish("Tracking_Search", { search_term: text })
}
